import React from "react";
import styled from "styled-components";

export default styled.div`
    color: black;
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    font-size: 16px;
`;